import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { _InfoForTaxCertificate } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { CertificateYears } from './CertificateYears/CertificateYears';
import { CertificateSheets } from './CertificateYears/CertificateSheets';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { toast } from 'react-toastify';


interface Props {
    yearid?: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const InfoForTaxCertificateEditor = ({ idSelector, onChange, label, returnType = "ID", render, yearid }: Props) => {

    const { instance, lista, setLista } = useDataBean(_InfoForTaxCertificate)
    const [id, setID] = useState(null);
    const [year, setyear] = useState<number>(yearid ?? null);
    const [sheetName, setsheetName] = useState<any>(null)
    const modal = useModal("Concepto de Certificado", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (year && sheetName) {
            getLista();
        }
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDInfoForTaxCertificate == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {
        instance.getInfoForTaxCertificateCatalog(year, sheetName).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }
    const head = [
        { title: 'ID', property: 'IDInfoForTaxCertificate', visible: true },
        { title: 'Hoja', property: 'SheetName', visible: true },
        { title: 'Nombre de Columna', property: 'ColumnName', visible: true },
        { title: 'Índice Columna', property: 'ColumnIndex', visible: true },
        { title: 'Tag de Columna', property: 'ColumnTag', visible: true },
        { title: 'Valor por Defecto', property: 'DefaultValue', visible: true },
        { title: 'Vigencia', property: 'Year', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo', property: 'ValueType', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
        {/* Aqui estuvo el error */}
            <label>{label ?? "Concepto de Certificado"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <CertificateYears idSelector={year} disable={typeof (yearid) == "number"} onChange={(e) => { setyear(e) }} />
                    </div>
                    <div className="col-md-6">
                        <CertificateSheets year={year} idSelector={sheetName} onChange={(e) => { setsheetName(e) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Buscar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDInfoForTaxCertificate); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}